import { useState } from 'react'
import { useSubscribe } from 'streamr-client-react'
import useIsMounted from '~hooks/useIsMounted'

const DATA_METADATA_STREAM_ID = '0x7d275b79eaed6b00eb1fe7e1174c1c6f2e711283/DATA-metadata'

export default function useRealtimeDataTokenStream() {
    const isMounted = useIsMounted()

    const [data, setData] = useState({
        DATAUSDPoint: 0,
        DATAUSDVolumePoint: 0,
        DATAUSDMarketCapPoint: 0,
        circulatingSupply: 0,
        totalSupply: 0,
    })

    useSubscribe(DATA_METADATA_STREAM_ID, {
        onMessage(msg) {
            if (!isMounted()) {
                return
            }

            const {
                DATAUSD,
                DATAUSDMarketCap,
                DATAUSDVolume,
                circulatingSupply,
                totalSupply,
            } = msg.getParsedContent()

            setData({
                DATAUSDPoint: Number.parseFloat(DATAUSD),
                DATAUSDVolumePoint: DATAUSDVolume,
                DATAUSDMarketCapPoint: DATAUSDMarketCap,
                circulatingSupply,
                totalSupply,
            })
        },
        resendOptions: {
            last: 1,
        },
    })

    return data
}
